export const updateEvent = new CustomEvent('update', { bubbles: true, composed: true });
export const updateSettingsEvent = new CustomEvent('updateSettingsEvent', { bubbles: true, composed: true });
export const updateTranslationEvent = new CustomEvent('updateTranslation', { bubbles: true, composed: true });
//# sourceMappingURL=updateEvent.js.map